import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class SessionTimeoutService {
  private interval: any;
  private TIMEOUT_IN: number = 1000 * 60 * 15; // 15 minutes
  public redirectUrl: string;

  constructor(public router: Router) { }

  refreshTimer() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    let lastTimeoutRefreshTimestamp = Number(
      sessionStorage.getItem("lastTimeoutRefreshTimestamp")
    );

    this._validateLastRefreshTimestamp(lastTimeoutRefreshTimestamp);
    this._updateLastRefreshTimestamp(lastTimeoutRefreshTimestamp);

    this.interval = setInterval(() => {
      sessionStorage.clear();
      window.location.reload();
      clearInterval(this.interval);
      this._toTimeoutRoute();
    }, this.TIMEOUT_IN);
  }

  setRedirectUrl(url: string) {
    this.redirectUrl = url;
  }

  /**
   * Validates the last saved session refresh timestamp
   */
  private _validateLastRefreshTimestamp(lastTimeoutRefreshTimestamp) {
    let currentTimestamp = Date.now();
    if (
      lastTimeoutRefreshTimestamp !== 0 &&
      lastTimeoutRefreshTimestamp < currentTimestamp
    ) {
      sessionStorage.clear();
      this._toTimeoutRoute();
    }
  }

  /**
   * Updates the timeout refresh timestamp stored in session storage
   */
  private _updateLastRefreshTimestamp(lastTimeoutRefreshTimestamp) {
    lastTimeoutRefreshTimestamp = Date.now() + this.TIMEOUT_IN;
    sessionStorage.setItem(
      "lastTimeoutRefreshTimestamp",
      String(lastTimeoutRefreshTimestamp)
    );
  }

  /**
   * Correctly redirect to timeout modal depending the base bath in redirectUrl
   */
  private _toTimeoutRoute() {
    if (this.redirectUrl.indexOf("portal") > -1) {
      this.router.navigate(["/timeout"]);
    } else if (this.redirectUrl.indexOf("admin-portal") > -1) {
      this.router.navigate(["/admin-portal/timeout"]);
    } else {
      console.log("Redirect url was not set. Something went wrong.");
      throw new Error("redirectUrl not set in session-timeout service");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/session-timeout/session-timeout.service.ts